<div class="p-r-2 p-b-2 p-l-2 pe-none _wrapper">
    <div class="w-12 pos-relative pe-auto _inner">
        <div class="w-12 p-r-2 p-l-2 inline-flex flex-middle flex-justify-center b-radius-max bg-col-35 col-12 center _content"
             [sizeClass]="'!S: p2, S: c1'">
            @if (login()) {
            <p class="cursor-pointer _message"
               [iCmsModalOpen]="'login-form-modal'">
                <span class="fw-bold">{{'Create an account' | translate}}</span>&nbsp;
                {{'or' | translate}}&nbsp;<span class="fw-bold">{{'sign in' | translate}}</span>&nbsp;
                {{'to save your wishlist' | translate}}.
            </p>
            } @else if (beforeAdd()) {
            <span class="fw-bold no-wrap">{{'Select your % to add to your wishlist' | translate :
                missingAttrLabel()}}</span>
            } @else if (already()) {
            <span class="fw-bold">
                {{'Selected % % is already in your wishlist' | translate : missingAttrLabel() : optionLabel()}}
            </span>
            <action class="m-l-2 button-inline underline"
                    [status]="status"
                    (click)="remove()">{{'Remove' | translate}}</action>
            } @else {
            <a rel="nofollow"
               [routerLink]="'/account/wishlist'">
                @if (optionValue()) {
                <span class="fw-bold">{{missingAttrLabel()}} {{optionLabel()}}</span>
                {{'was added to your wishlist' | translate}}
                } @else {
                @if (!client.isS) {
                {{'The item was added to your wishlist' | translate}}
                } @else {
                {{'Added to your wishlist' | translate}}
                }
                }
            </a>
            }
        </div>
    </div>
</div>